import paynowQr from "../assets/images/MainCarnNTUSOPayNowQRCode.png";

/**
 * S3 image URLs for AFTH frontend.
 * Base folder: https://afth-frontend.s3.us-east-1.amazonaws.com/static/media/
 * File names match the assets in that S3 folder (from Website Information document).
 */
const S3_MEDIA_BASE =
  "https://afth-frontend.s3.us-east-1.amazonaws.com/static/media";

function s3Url(filename) {
  return `${S3_MEDIA_BASE}/${encodeURIComponent(filename)}`;
}

export const S3_IMAGES = {
  /** Home page hero banner (PDF: "Home page picture") */
  HOME_HERO: s3Url("Arts from the Hearts 2425.png"),
  /** Ticket/event main image (PDF: "main pic", "About Us Page picture - same as ticket main pic") */
  TICKET_MAIN: s3Url("tix pic.jpg"),
  /** PayNow QR code (Main Carn NTU SO PayNow QR Code) */
  PAYNOW_QR: paynowQr,
  /** Gallery images for ticket (PDF: "Gallery pics for the ticket") */
  GALLERY: [
    s3Url("LJX00527.jpg"),
    s3Url("LJX00078.jpg"),
    s3Url("_DSC9969.jpg"),
    s3Url("_DSC0025.jpg"),
  ],
};

export default S3_IMAGES;
